/**
 * Symbol normalization for tickers entering Hearth at any UI surface
 * (rule create, watchlist add, etc.). Mirror of
 * `shared/src/util/merrill-ticker-map.ts` — web does NOT import from
 * `@hearth/shared` per the 5.1 lock. Keep the two files in sync when
 * new mappings are added.
 *
 * New entries land here AND in shared/. Pattern-based normalization
 * (e.g. ".B" → "-B") is tempting but brittle; Tiingo's actual
 * divergences aren't a single pattern.
 */

export const MERRILL_TICKER_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    // Berkshire B-class shares: Tiingo uses BRK-B; Merrill uses BRKB.
    BRKB: "BRK-B",
  });

/**
 * Uppercase the input, strip whitespace, then look up in the map. If
 * the input matches a Merrill-side key, return the Tiingo form;
 * otherwise return the cleaned input. Never throws.
 */
export function normalizeTicker(raw: string): string {
  const cleaned = raw.trim().toUpperCase();
  return MERRILL_TICKER_MAP[cleaned] ?? cleaned;
}
